webpackJsonp([224248516069615],{

/***/ 283:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"leader_item":"src-components-team-leader-item----TeamLeaderItem-module---leader_item---130C0","photo_col":"src-components-team-leader-item----TeamLeaderItem-module---photo_col---3YqnW","profile":"src-components-team-leader-item----TeamLeaderItem-module---profile---1vAj4","job_title":"src-components-team-leader-item----TeamLeaderItem-module---job_title---3lH3g","name":"src-components-team-leader-item----TeamLeaderItem-module---name---2YmQi","degree":"src-components-team-leader-item----TeamLeaderItem-module---degree---14CZC","description":"src-components-team-leader-item----TeamLeaderItem-module---description---2eSpm","contact_details":"src-components-team-leader-item----TeamLeaderItem-module---contact_details---HSi3E","member_link_list":"src-components-team-leader-item----TeamLeaderItem-module---member_link_list---c2cQN","member_link_item":"src-components-team-leader-item----TeamLeaderItem-module---member_link_item---c1Yik","member_link":"src-components-team-leader-item----TeamLeaderItem-module---member_link---1orWA"};

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TeamLeaderItemModule = __webpack_require__(283);
	
	var _TeamLeaderItemModule2 = _interopRequireDefault(_TeamLeaderItemModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkup(value) {
		return {
			__html: value
		};
	}
	
	var TeamLeaderItem = function TeamLeaderItem(_ref) {
		var locale = _ref.locale,
		    photo = _ref.photo,
		    slug = _ref.slug,
		    job_title = _ref.job_title,
		    researchInterests = _ref.researchInterests,
		    name = _ref.name,
		    degree = _ref.degree,
		    bio = _ref.bio,
		    email = _ref.email,
		    profile_url = _ref.profile_url,
		    pubMed = _ref.pubMed,
		    researchGate = _ref.researchGate,
		    mahidolProfile = _ref.mahidolProfile,
		    linkedInProfile = _ref.linkedInProfile;
		return _react2.default.createElement(
			"div",
			{ className: "col-12 " + _TeamLeaderItemModule2.default.leader_item },
			_react2.default.createElement(
				"div",
				{ className: "row justify-content-between" },
				_react2.default.createElement("div", {
					className: _TeamLeaderItemModule2.default.photo_col,
					style: {
						backgroundImage: "url(" + photo + ")"
					}
				}),
				_react2.default.createElement(
					"div",
					{ className: _TeamLeaderItemModule2.default.profile },
					_react2.default.createElement(
						"small",
						{ className: _TeamLeaderItemModule2.default.job_title },
						job_title,
						" | ",
						researchInterests[0].title
					),
					slug ? _react2.default.createElement(
						"h4",
						{ className: _TeamLeaderItemModule2.default.name },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: "/" + locale + "/team/" + slug },
							name
						)
					) : _react2.default.createElement(
						"h4",
						{ className: _TeamLeaderItemModule2.default.name },
						name
					),
					_react2.default.createElement(
						"small",
						{ className: _TeamLeaderItemModule2.default.degree },
						degree
					),
					_react2.default.createElement("span", {
						className: _TeamLeaderItemModule2.default.description,
						dangerouslySetInnerHTML: createMarkup(bio.html)
					}),
					_react2.default.createElement(
						"div",
						{ className: _TeamLeaderItemModule2.default.contact_details },
						email && _react2.default.createElement(
							"span",
							null,
							_react2.default.createElement("i", { className: "envelope" }),
							email
						)
					),
					_react2.default.createElement(
						"ul",
						{ className: _TeamLeaderItemModule2.default.member_link_list },
						pubMed && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: pubMed,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"Publications"
							)
						),
						researchGate && researchGate !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: researchGate,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"ResearchGate"
							)
						),
						mahidolProfile && mahidolProfile !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: mahidolProfile,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"Mahidol Profile"
							)
						),
						linkedInProfile && linkedInProfile !== "-" && _react2.default.createElement(
							"li",
							{ className: _TeamLeaderItemModule2.default.member_link_item },
							_react2.default.createElement(
								"a",
								{
									href: linkedInProfile,
									target: "_blank",
									className: _TeamLeaderItemModule2.default.member_link
								},
								"LinkedIn"
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = TeamLeaderItem;
	module.exports = exports["default"];

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wide_row":"src-styles----team-module---wide_row---3Uiqk","hr_long":"src-styles----team-module---hr_long---3tXeJ","small_item":"src-styles----team-module---small_item---1SkM2","career_list":"src-styles----team-module---career_list---2wGTR","jumbo_p":"src-styles----team-module---jumbo_p---1B3Xi","career_row":"src-styles----team-module---career_row---2Qg2t","go_back":"src-styles----team-module---go_back---12Z2J"};

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _teamLeaderItem = __webpack_require__(244);
	
	var _teamLeaderItem2 = _interopRequireDefault(_teamLeaderItem);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _teamModule = __webpack_require__(288);
	
	var _teamModule2 = _interopRequireDefault(_teamModule);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePage = function ProfilePage(_ref) {
		var transition = _ref.transition,
		    pathContext = _ref.pathContext,
		    data = _ref.data,
		    location = _ref.location;
		var profile = data.profile;
	
		var cta = data.cta.edges[0].node;
		return _react2.default.createElement(
			_PageWrapper2.default,
			{
				locale: profile.node_locale,
				location: location,
				data: data.layout.edges[0].node
			},
			_react2.default.createElement(
				"main",
				{ role: "main", style: transition && transition.style },
				_react2.default.createElement(_reactHelmet2.default, {
					title: profile.fullName + " | " + (profile.node_locale === "th" ? "ทีม" : "Team") + " | Mahidol Vivax Research Unit",
					meta: [{
						name: "description",
						content: profile.shortBio.content
					}, {
						name: "keywords",
						content: "malaria, vivax, mahidol, tropical medicine, lab, laboratory"
					}, {
						name: "og:title",
						content: profile.fullName + " | " + (profile.node_locale === "th" ? "ทีม" : "Team") + " | Mahidol Vivax Research Unit"
					}, {
						name: "og:description",
						content: profile.shortBio.content
					}, {
						name: "og:image",
						content: profile.profilePicture.sizes.src
					}]
				}),
				_react2.default.createElement(
					"div",
					{
						id: "navColorReference",
						style: { background: "white" },
						className: "container mt-5 mb-1 " + _teamModule2.default.go_back
					},
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: "/" + profile.node_locale + "/team" },
							"\xAB",
							" ",
							profile.node_locale === "th" ? "กลับไปที่หน้าทีม" : "Go back to Team page"
						)
					)
				),
				_react2.default.createElement(
					"div",
					{
						className: "grey_bg pb-5",
						style: { position: "relative" }
					},
					_react2.default.createElement(
						"div",
						{ className: "white_bg" },
						_react2.default.createElement(
							"div",
							{ className: "container " },
							_react2.default.createElement(
								"div",
								{ className: _teamModule2.default.wide_row },
								_react2.default.createElement(_teamLeaderItem2.default, {
									locale: profile.node_locale,
									photo: profile.profilePicture.sizes.src,
									job_title: profile.jobTitle,
									researchInterests: profile.researchInterests,
									name: profile.fullName,
									degree: profile.academicDegree,
									bio: profile.shortBio.content,
									email: profile.email,
									pubMed: profile.pubMedPublications,
									researchGate: profile.researchGateUrl,
									mahidolProfile: profile.mahidolProfileUrl,
									linkedInProfile: profile.linkedInUrl
								})
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "container " },
						profile.grantsHistory && _react2.default.createElement(
							"div",
							{
								className: _teamModule2.default.wide_row + " justify-content-between " + _teamModule2.default.career_list
							},
							_react2.default.createElement(
								"div",
								{ className: "col-12 mb-3" },
								_react2.default.createElement(
									"h3",
									null,
									"Grants history"
								)
							),
							profile.grantsHistory && profile.grantsHistory.map(function (item, ixx) {
								return _react2.default.createElement(CareerRow, {
									key: "history-" + ixx,
									logo: item.funderLogo,
									funder: item.funderName,
									description: item.title,
									when: item.date
								});
							})
						),
						profile.project && _react2.default.createElement(
							"div",
							{
								className: _teamModule2.default.wide_row + " " + _teamModule2.default.career_list
							},
							_react2.default.createElement(
								"div",
								{ className: "col-12 mb-3" },
								_react2.default.createElement(
									"h3",
									null,
									"Collaborations"
								)
							),
							profile.project && profile.project.map(function (item, ixx) {
								return _react2.default.createElement(CareerRow, {
									key: "history-" + ixx,
									logo: item.funders && item.funders[0].logo,
									funder: item.funders && item.funders[0].name,
									description: item.title,
									when: item.date
								});
							})
						),
						profile.awards && _react2.default.createElement(
							"div",
							{
								className: _teamModule2.default.wide_row + " " + _teamModule2.default.career_list
							},
							_react2.default.createElement(
								"div",
								{ className: "col-12 mb-3" },
								_react2.default.createElement(
									"h3",
									null,
									"Awards"
								)
							),
							profile.awards && profile.awards.map(function (item, ixx) {
								return _react2.default.createElement(CareerRow, {
									key: "history-" + ixx,
									description: item.title,
									when: item.date
								});
							})
						)
					)
				),
				_react2.default.createElement(_CallToAction2.default, {
					className: "my-5",
					leadText: cta.leadingText,
					text: cta.content.childMarkdownRemark.html,
					buttonLabel: cta.buttonLabel,
					destination: "/" + profile.node_locale + cta.linkTo,
					arrow: true
				})
			)
		);
	};
	
	exports.default = ProfilePage;
	
	
	var CareerRow = function CareerRow(_ref2) {
		var logo = _ref2.logo,
		    description = _ref2.description,
		    when = _ref2.when,
		    funder = _ref2.funder;
		return _react2.default.createElement(
			"div",
			{ className: "col-12 py-3" },
			_react2.default.createElement(
				"div",
				{ className: "row align-items-center " + _teamModule2.default.career_row },
				_react2.default.createElement(
					"div",
					{ className: "col-8 col-md-3 text-center" },
					logo && _react2.default.createElement(_gatsbyImage2.default, { title: funder, alt: funder, sizes: logo.sizes })
				),
				_react2.default.createElement(
					"div",
					{ className: "col-12 col-md-7 " },
					description
				),
				_react2.default.createElement(
					"div",
					{ className: "col-12  col-md-2 text-center" },
					when
				)
			)
		);
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-profile-template-js-f5fe8ff2fc212a9f8fb3.js